// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".resourceNew[data-v-52824b72]{background-color:#fff;padding:0 10px 10px 10px;height:100%}.top-tabs[data-v-52824b72]{height:100%;display:flex;flex-direction:column}.resourceNew .top-tabs[data-v-52824b72] .el-tabs__nav-scroll{margin-left:20px}.resourceList[data-v-52824b72]{height:100%}[data-v-52824b72] .el-tabs__content{flex:1}[data-v-52824b72] .el-tab-pane{height:100%}", ""]);
// Exports
module.exports = exports;
